export function classifyRegistrationError(
    message: string
  ): "file" | "url" | "format" | "memory" | "database" | "unknown" {
    const msg = message.toLowerCase();
    if (msg.includes("file") || msg.includes("not found")) return "file";
    if (msg.includes("http") || msg.includes("fetch")) return "url";
    if (msg.includes("format") || msg.includes("parse")) return "format";
    if (msg.includes("memory") || msg.includes("buffer")) return "memory";
    if (msg.includes("connection") || msg.includes("database")) return "database";
    return "unknown";
  }
  